export const LOGIN = 'login';
export const LOGOUT = 'logOut';
export const FORGOT_PASSWORD = 'forgotPassword';
export const RESET_PASSWORD = 'resetPassword';
export const FIRST_TIME = 'firstTime';

export const GET_USER = 'getUser';
export const GET_USER_JWT = 'getUserJWT';
export const SET_PASSWORD = 'setPassword';
export const UPDATE_ACCOUNT = 'updateAccount';